<section id="experience">
  <div class="master-container">
    <div class="top-fungi">
      <img src="" alt="Icono hongo superior" i18n-alt srcset="">
    </div>
    <div class="bottom-fungi">
      <img src="" alt="Icono hongo inferior" i18n-alt srcset="">
    </div>
    <div class="container text-center top-container">
      <h2 class="text-uppercase" i18n>Amplia experiencia en coaching</h2>
      <p class="text-center mw-large mx-auto mt-3" i18n>En los últimos seis años, hemos tratado a más de 6,000 personas
        con protocolos personalizados de microdosis, lo que convierte nuestro trabajo en uno de los estudios
        independientes más grandes del mundo. Nuestro equipo está compuesto por más de 54 profesionales, incluyendo
        psiquiatras, psicólogos, biólogos y coaches de alto rendimiento, muchos de los cuales cuentan con décadas de
        experiencia. Nuestro enfoque se basa en conocimientos extraídos de más de 300 publicaciones en revistas
        científicas, estudios y ensayos clínicos.
      </p>
    </div>
    <div class="container-fluid">
      <div class="row p-5 gap-5 gap-md-0">
        <div class="col-md text-center ">
          <div class="number-container container justify-content-center">
            <h2 class="h1_mask">
              6,000 +
            </h2>
          </div>
          <div>
            <hr *ngIf="!this.mobile">
          </div>
          <div>
            <p class="text-center" i18n>
              El número de personas en los últimos seis años con protocolos de microdosis personalizados (uno de
              los más grandes
              estudios independientes en el mundo).
            </p>
          </div>
        </div>
        <div class="col-md text-center">
          <div class="number-container container justify-content-center">
            <h2 class="h1_mask">
              800
            </h2>
          </div>
          <div>
            <hr *ngIf="!this.mobile">
          </div>
          <div>
            <p class="text-center" i18n>
              Número de personas a las que hemos ayudado hasta ahora a reducir gradualmente los antidepresivos
              convencionales (96% de tasa de éxito).
            </p>
          </div>
        </div>
        <div class="col-md text-center">
          <div class="number-container container justify-content-center">
            <h2 class="h1_mask">
              180
            </h2>
          </div>
          <div>
            <hr *ngIf="!this.mobile">
          </div>
          <div>
            <p class="text-center" i18n>
              El número de hongos que hemos estudiado para desarrollar nuestro extenso programa de creación de
              protocolos.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>